import { matter } from '../../api/matter';
import { IframeWindow } from '.';
import { BaseRequest } from 'api';

export class Matter implements matter.Api {
  constructor(private iframe: IframeWindow) {}

  openTable(request: matter.OpenTableRequest): void {
    this.iframe.postMessage({
      command: 'matter.openTable',
      args: request,
    });
  }

  openMatter(request: matter.OpenMatterRequest): void {
    this.iframe.postMessage({
      command: 'matter.openMatter',
      args: request,
    });
  }

  selectMatter(request?: matter.SelectMatterRequest): Promise<matter.Matter[]> {
    return this.iframe.twoWayCall<BaseRequest, matter.Matter[]>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'matter.selectMatter',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        return response;
      }
    );
  }

  // getLists(request: BaseRequest): Promise<matter.MatterResult[]> {
  //   return this.iframe.twoWayCall<BaseRequest, matter.MatterResult[]>(
  //     request,
  //     (requestId, request) => {
  //       this.iframe.postMessage({
  //         command: 'matter.getLists',
  //         args: {
  //           ...request,
  //           requestId,
  //         },
  //       });
  //     },
  //     (response) => {
  //       let responseData;
  //       try {
  //         responseData = JSON.parse(response);
  //       } catch (e) {
  //         // Unable to parse response => response is not a stringify object
  //         responseData = response;
  //       }
  //       return responseData;
  //     }
  //   );
  // }
}
